import { render, staticRenderFns } from "./EditAppointmentClient.vue?vue&type=template&id=35ff62d6&scoped=true"
import script from "./EditAppointmentClient.vue?vue&type=script&lang=js"
export * from "./EditAppointmentClient.vue?vue&type=script&lang=js"
import style0 from "./EditAppointmentClient.vue?vue&type=style&index=0&id=35ff62d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff62d6",
  null
  
)

export default component.exports